module.exports = __webpack_public_path__ + "static/media/mulan-win.cac341d6.png";